// import React, { useEffect, useState } from "react";
// // import apiClient from "../api/axiosClient"; // Uncomment when API is ready
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
//   IconButton,
//   InputAdornment,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Box,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { Visibility, VisibilityOff, Send, VerifiedUser } from "@mui/icons-material";
// import CloseIcon from "@mui/icons-material/Close";

// // Configuration flag - set to true when API is ready
// const USE_API = false;

// // Static registered users storage (in-memory for demo)
// let staticRegisteredUsers = [
//   { email: "user@demo.com", password: "user123", role: "user" },
//   { email: "admin@demo.com", password: "admin123", role: "admin" }
// ];

// const ORGANISATION_OPTIONS = [
//   "Adani Welspun Exploration Limited",
//   "ASAP Fluids Private Limited",
//   "Axens India (P) Limited",
//   "Baker Hughes",
//   "Bharat Petroleum Corporation Limited",
//   "Bliss Anand Private Limited",
//   "BP Exploration (Alpha) Limited",
//   "Cairn Oil & Gas, Vedanta Limited",
//   "Central U.P. Gas Limited",
//   "Chennai Petroleum Corporation Limited",
//   "Dynamic Drilling & Services Pvt. Limited",
//   "Engineers India Limited",
//   "Ernst & Young LLP",
//   "ExxonMobil Gas (India) Pvt. Limited",
//   "FMC Technologies India Private Limited",
//   "GAIL (India) Limited",
//   "Goa Natural Gas Private Limited",
//   "GSPC LNG Limited",
//   "Hindustan Petroleum Corporation Limited",
//   "HPCL-Mittal Energy Limited",
//   "IMC Limited",
//   "Indian Gas Exchange Limited",
//   "Indian Oil Corporation Limited",
//   "Indian Strategic Petroleum Reserves Limited",
//   "IndianOil Adani Ventures Limited",
//   "Indraprastha Gas Limited",
//   "Indradhanush Gas Grid Limited",
//   "IRM Energy Private Limited",
//   "Jindal Drilling & Industries Limited",
//   "LanzaTech Private Limited",
//   "Larsen & Toubro Ltd.",
//   "Mangalore Refinery & Petrochemicals Limited",
//   "Marine Solutionz Ship Management Private Limited",
//   "Nayara Energy Limited",
//   "Numaligarh Refinery Limited",
//   "Oil & Natural Gas Corporation Limited",
//   "Oil India Limited",
//   "Petronet LNG Limited",
//   "Petronet MHB Limited",
//   "Pipeline Infrastructure Limited",
//   "Reliance BP Mobility Limited",
//   "Reliance Industries Limited",
//   "S&P Global Commodity Insights",
//   "Seros Energy Private Limited",
//   "Shell Companies in India",
//   "Siemens Limited",
//   "SLB",
//   "South Asia Gas Enterprise Pvt. Limited",
//   "Sun Petrochemicals Private Limited",
//   "THINK Gas Distribution Pvt. Ltd.",
//   "Topso A/S",
//   "TotalEnergies Gas & Power Projects India Pvt. Ltd.",
//   "VCS Quality Services Private Limited",
//   "Other",
// ];

// const MessageCard = ({ open, severity = "info", message = "", onClose }) => {
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     if (open) {
//       const t = setTimeout(() => setVisible(true), 10);
//       const hide = setTimeout(() => {
//         setVisible(false);
//         setTimeout(() => onClose && onClose(), 300);
//       }, 6000);
//       return () => {
//         clearTimeout(t);
//         clearTimeout(hide);
//       };
//     } else {
//       setVisible(false);
//     }
//   }, [open, onClose]);

//   if (!open && !visible) return null;

//   const palette = {
//     success: { bg: "linear-gradient(135deg,#7ee787,#28c76f)", accent: "#0a7a3b", iconBg: "rgba(255,255,255,0.14)" },
//     error: { bg: "linear-gradient(135deg,#ff9a9e,#ff6b6b)", accent: "#c40000", iconBg: "rgba(255,255,255,0.14)" },
//     warning: { bg: "linear-gradient(135deg,#ffd89b,#ffb347)", accent: "#b35b00", iconBg: "rgba(255,255,255,0.14)" },
//     info: { bg: "linear-gradient(135deg,#a1c4fd,#c2e9fb)", accent: "#1a73e8", iconBg: "rgba(255,255,255,0.14)" },
//   }[severity] || { bg: "linear-gradient(135deg,#e0e0e0,#bdbdbd)", accent: "#333", iconBg: "rgba(255,255,255,0.14)" };

//   const containerStyle = {
//     position: "fixed",
//     left: "50%",
//     top: "24px",
//     transform: `translateX(-50%) translateY(${visible ? "0" : "18px"})`,
//     opacity: visible ? 1 : 0,
//     transition: "transform 260ms cubic-bezier(.2,.9,.2,1), opacity 260ms ease",
//     zIndex: 1400,
//     minWidth: "260px",
//     maxWidth: "92%",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
//     borderRadius: "14px",
//     overflow: "hidden",
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     padding: "12px 14px",
//     background: palette.bg,
//     color: "#0a0a0a",
//     fontFamily: "Inter, Roboto, sans-serif",
//     border: `1px solid rgba(255,255,255,0.12)`,
//     backdropFilter: "blur(6px)",
//   };

//   const iconCircle = {
//     width: 40,
//     height: 40,
//     borderRadius: 10,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     background: palette.iconBg,
//     boxShadow: "inset 0 -4px 10px rgba(0,0,0,0.08)",
//     flexShrink: 0,
//   };

//   const textStyle = { display: "flex", flexDirection: "column", gap: 2, lineHeight: 1.15 };
//   const titleStyle = { fontSize: 13, fontWeight: 700, color: "#062b18", letterSpacing: "0.1px" };
//   const messageStyle = {
//     fontSize: 12,
//     color: "rgba(6,43,24,0.9)",
//     opacity: 0.95,
//     marginTop: 2,
//     maxWidth: 420,
//     wordBreak: "break-word",
//   };

//   const closeBtnStyle = {
//     marginLeft: "auto",
//     border: "none",
//     background: "transparent",
//     cursor: "pointer",
//     padding: 6,
//     borderRadius: 8,
//     color: "rgba(10,10,10,0.6)",
//   };

//   const titleMap = { success: "Success", error: "Error", warning: "Warning", info: "Info" };

//   return (
//     <div role="status" aria-live="polite" style={containerStyle}>
//       <div style={iconCircle}>
//         <div style={{ fontSize: 18, fontWeight: 700, color: palette.accent }}>
//           {severity === "success" ? "✓" : severity === "error" ? "!" : severity === "warning" ? "!" : "i"}
//         </div>
//       </div>

//       <div style={textStyle}>
//         <div style={titleStyle}>{titleMap[severity] || "Notice"}</div>
//         <div style={messageStyle}>{message}</div>
//       </div>

//       <button
//         aria-label="close message"
//         onClick={() => {
//           setVisible(false);
//           setTimeout(() => onClose && onClose(), 260);
//         }}
//         style={closeBtnStyle}
//       >
//         <CloseIcon fontSize="small" />
//       </button>
//     </div>
//   );
// };

// const RegisterModal = ({ onClose, onRegisterSuccess, open = true }) => {
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     applicant_name: "",
//     applicant_phone: "",
//     designation: "",
//     organisation_name: "",
//     email: "",
//     password: "",
//     confirm_password: "",
//   });

//   // OTP related
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [isOtpVerified, setIsOtpVerified] = useState(false);

//   const [snack, setSnack] = useState({ open: false, severity: "info", message: "" });
//   const [showOtherOrgInput, setShowOtherOrgInput] = useState(false);
//   const [passwordHelp, setPasswordHelp] = useState("");

//   // auto-fill applicant_name from first + last
//   useEffect(() => {
//     const fn = formData.first_name.trim();
//     const ln = formData.last_name.trim();
//     const combined = (fn || ln) ? `${fn} ${ln}`.trim() : "";
//     setFormData((prev) => ({ ...prev, applicant_name: combined }));
//   }, [formData.first_name, formData.last_name]);

//   const handlePhoneChange = (value) => {
//     const digits = value.replace(/\D/g, "");
//     if (digits.length <= 10) {
//       setFormData((p) => ({ ...p, applicant_phone: digits }));
//     }
//   };

//   const handleOrgSelect = (value) => {
//     if (value === "Other") {
//       setShowOtherOrgInput(true);
//       setFormData((p) => ({ ...p, organisation_name: "" }));
//     } else {
//       setShowOtherOrgInput(false);
//       setFormData((p) => ({ ...p, organisation_name: value }));
//     }
//   };

//   const validatePassword = (pw) => {
//     if (!pw || pw.length < 6) {
//       return { ok: false, msg: "Password must be at least 6 characters." };
//     }
//     if (!/\d/.test(pw)) {
//       return { ok: false, msg: "Password must contain at least one number." };
//     }
//     if (!/[!@#$%^&*(),.?":{}|<>_\-\\[\]\/;`~+=]/.test(pw)) {
//       return { ok: false, msg: "Password must contain at least one special character." };
//     }
//     return { ok: true };
//   };

//   const handlePasswordChange = (value) => {
//     setFormData((p) => ({ ...p, password: value }));
//     const v = validatePassword(value);
//     setPasswordHelp(v.ok ? "" : v.msg);
//   };

//   const showMessage = ({ severity = "info", message = "" }) => {
//     setSnack({ open: true, severity, message });
//   };

//   const BLOCKED_PUBLIC_DOMAINS = ["gmail.com", "yahoo.com", "outlook.com", "rediff.com", "hotmail.com"];

//   const isEmailAllowedForOrg = (organisationName, email) => {
//     if (!organisationName || organisationName === "Other") return true;
//     if (!email || !email.includes("@")) return false;
//     const domain = email.trim().split("@").pop().toLowerCase();
//     return !BLOCKED_PUBLIC_DOMAINS.includes(domain);
//   };

//   const canSendOtp =
//     Boolean(formData.email && formData.email.trim()) &&
//     (showOtherOrgInput ? Boolean(formData.organisation_name && formData.organisation_name.trim()) : Boolean(formData.organisation_name && formData.organisation_name !== ""));

//   // Static OTP simulation
//   const handleSendOtp = async () => {
//     if (!formData.email) {
//       return showMessage({ severity: "warning", message: "Enter email first to send OTP." });
//     }

//     if (!isEmailAllowedForOrg(formData.organisation_name, formData.email)) {
//       return showMessage({
//         severity: "warning",
//         message: "Enter Organisation official mail id Only.",
//       });
//     }

//     // Check if email already exists in static storage
//     const emailExists = staticRegisteredUsers.some(
//       user => user.email.toLowerCase() === formData.email.toLowerCase()
//     );

//     if (emailExists) {
//       return showMessage({
//         severity: "warning",
//         message: "This email is already registered. Please login or use 'Forgot password' to reset your password.",
//       });
//     }

//     setIsOtpVerified(false);
//     setOtp("");
//     setOtpLoading(true);

//     if (USE_API) {
//       // API call here when ready
//       /*
//       try {
//         await apiClient.post("/otp/generate/", { email: formData.email });
//         setOtpSent(true);
//         showMessage({ severity: "success", message: `OTP sent to ${formData.email}` });
//       } catch (err) {
//         const resp = err.response?.data;
//         const respText = resp ? (typeof resp === "string" ? resp : JSON.stringify(resp)) : err.message || "";
//         const alreadyRegistered = err.response?.status === 400 && /already|exists|registered/i.test(respText);

//         if (alreadyRegistered) {
//           showMessage({
//             severity: "warning",
//             message: "This email is already registered. Please login or use 'Forgot password' to reset your password.",
//           });
//           setOtpSent(false);
//           setIsOtpVerified(false);
//           setOtp("");
//         } else {
//           const msg = resp?.detail || respText || err.message;
//           showMessage({ severity: "error", message: `Failed to send OTP: ${JSON.stringify(msg)}` });
//         }
//       }
//       */
//     } else {
//       // Static mode - simulate OTP send
//       setTimeout(() => {
//         setOtpSent(true);
//         setOtpLoading(false);
//         showMessage({ 
//           severity: "success", 
//           message: `OTP sent to ${formData.email} (Static mode: use any 6-digit code)` 
//         });
//       }, 1000);
//       return;
//     }

//     setOtpLoading(false);
//   };

//   const handleVerifyOtp = async () => {
//     if (!otp) return showMessage({ severity: "warning", message: "Enter OTP to verify." });

//     if (!isEmailAllowedForOrg(formData.organisation_name, formData.email)) {
//       return showMessage({
//         severity: "warning",
//         message: "Enter Organisation official mail id Only.",
//       });
//     }

//     setOtpLoading(true);

//     if (USE_API) {
//       // API call here when ready
//       /*
//       try {
//         const res = await apiClient.post("/otp/validate/", { email: formData.email, otp });
//         if (res.data?.valid) {
//           setIsOtpVerified(true);
//           showMessage({ severity: "success", message: "OTP verification successful." });
//         } else {
//           showMessage({ severity: "error", message: "OTP validation failed." });
//         }
//       } catch (err) {
//         const data = err.response?.data;
//         const reason = data?.reason || JSON.stringify(data) || err.message;
//         showMessage({ severity: "error", message: `OTP verification failed: ${reason}` });
//       }
//       */
//     } else {
//       // Static mode - accept any 6-digit OTP
//       setTimeout(() => {
//         if (otp.length === 6) {
//           setIsOtpVerified(true);
//           setOtpLoading(false);
//           showMessage({ severity: "success", message: "OTP verification successful (Static mode)." });
//         } else {
//           setOtpLoading(false);
//           showMessage({ severity: "error", message: "Please enter a 6-digit OTP." });
//         }
//       }, 800);
//       return;
//     }

//     setOtpLoading(false);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (formData.password !== formData.confirm_password) {
//       return showMessage({ severity: "error", message: "Passwords do not match." });
//     }
    
//     const pwCheck = validatePassword(formData.password);
//     if (!pwCheck.ok) {
//       return showMessage({ severity: "warning", message: `Your password is too weak: ${pwCheck.msg}` });
//     }

//     if (formData.applicant_phone.length !== 10) {
//       return showMessage({ severity: "error", message: "Applicant phone must be 10 digits." });
//     }

//     if (!isEmailAllowedForOrg(formData.organisation_name, formData.email)) {
//       return showMessage({
//         severity: "warning",
//         message: "Enter Organisation official mail id Only.",
//       });
//     }

//     if (!isOtpVerified) {
//       return showMessage({ severity: "warning", message: "Please verify OTP before registering." });
//     }

//     setLoading(true);

//     if (USE_API) {
//       // API registration here when ready
//       /*
//       try {
//         await apiClient.post("/auth/register/", {
//           first_name: formData.first_name,
//           last_name: formData.last_name,
//           applicant_name: formData.applicant_name,
//           applicant_phone: formData.applicant_phone,
//           designation: formData.designation,
//           organisation_name: formData.organisation_name,
//           email: formData.email,
//           password: formData.password,
//         });

//         showMessage({ severity: "success", message: "Registered successfully. Attempting auto-login..." });

//         // Auto-login
//         try {
//           const loginRes = await apiClient.post("/auth/login/", {
//             email: formData.email,
//             password: formData.password,
//           });
//           const { access, refresh } = loginRes.data || {};
//           if (access) {
//             sessionStorage.setItem("access_token", access);
//             sessionStorage.setItem("refresh_token", refresh || "");
//             apiClient.defaults.headers.common["Authorization"] = `Bearer ${access}`;
//           }
//         } catch (loginErr) {
//           console.warn("Auto-login failed:", loginErr);
//           showMessage({ severity: "info", message: "Registered but auto-login failed. Please login manually." });
//         }

//         setLoading(false);
//         onRegisterSuccess && onRegisterSuccess();
//         onClose && onClose();
//       } catch (err) {
//         setLoading(false);
//         const resp = err.response?.data;
//         const respText = resp ? (typeof resp === "string" ? resp : JSON.stringify(resp)) : err.message || "";
//         const alreadyRegistered =
//           err.response?.status === 400 &&
//           ( /already|exists|registered|user with this email/i.test(respText) ||
//             (resp && (resp.email || resp.detail)) );

//         if (alreadyRegistered) {
//           showMessage({ severity: "error", message: `${formData.email} is already registered.` });
//           return;
//         }

//         let msg = resp ? (typeof resp === "string" ? resp : JSON.stringify(resp)) : err.message;
//         showMessage({ severity: "error", message: `Registration failed: ${msg}` });
//       }
//       */
//     } else {
//       // Static mode - add to in-memory storage
//       setTimeout(() => {
//         // Check again if email exists
//         const emailExists = staticRegisteredUsers.some(
//           user => user.email.toLowerCase() === formData.email.toLowerCase()
//         );

//         if (emailExists) {
//           setLoading(false);
//           showMessage({ severity: "error", message: `${formData.email} is already registered.` });
//           return;
//         }

//         // Add new user to static storage
//         staticRegisteredUsers.push({
//           email: formData.email,
//           password: formData.password,
//           role: "user",
//           first_name: formData.first_name,
//           last_name: formData.last_name,
//           organisation_name: formData.organisation_name,
//           designation: formData.designation,
//           phone: formData.applicant_phone,
//         });

//         setLoading(false);
//         showMessage({ 
//           severity: "success", 
//           message: "Registered successfully! You can now login with your credentials." 
//         });

//         setTimeout(() => {
//           onRegisterSuccess && onRegisterSuccess();
//           onClose && onClose();
//         }, 1500);
//       }, 1000);
//     }
//   };

//   return (
//     <>
//       <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//         <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//           <Typography variant="h6">
//             Register
//           </Typography>
//           <IconButton onClick={onClose}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent dividers>
         

//           <Box component="form" onSubmit={handleSubmit} noValidate sx={{ display: "grid", gap: 2 }}>
//             <input type="hidden" name="applicant_name" value={formData.applicant_name} />

//             <Box sx={{ display: "flex", gap: 1 }}>
//               <TextField
//                 label="First Name"
//                 variant="outlined"
//                 required
//                 fullWidth
//                 value={formData.first_name}
//                 onChange={(e) => setFormData((p) => ({ ...p, first_name: e.target.value }))}
//               />
//               <TextField
//                 label="Last Name"
//                 variant="outlined"
//                 required
//                 fullWidth
//                 value={formData.last_name}
//                 onChange={(e) => setFormData((p) => ({ ...p, last_name: e.target.value }))}
//               />
//             </Box>

//             <TextField
//               label="Applicant Phone"
//               variant="outlined"
//               required
//               value={formData.applicant_phone}
//               onChange={(e) => handlePhoneChange(e.target.value)}
//               helperText={formData.applicant_phone && formData.applicant_phone.length !== 10 ? "Phone must be exactly 10 digits." : ""}
//               InputProps={{
//                 startAdornment: <InputAdornment position="start">+91</InputAdornment>,
//               }}
//             />

//             <TextField
//               label="Designation"
//               variant="outlined"
//               required
//               value={formData.designation}
//               onChange={(e) => setFormData((p) => ({ ...p, designation: e.target.value }))}
//             />

//             <FormControl fullWidth>
//               <InputLabel id="org-select-label">Organisation</InputLabel>
//               <Select
//                 labelId="org-select-label"
//                 value={showOtherOrgInput ? "Other" : formData.organisation_name || ""}
//                 label="Organisation"
//                 onChange={(e) => handleOrgSelect(e.target.value)}
//               >
//                 {ORGANISATION_OPTIONS.map((o) => (
//                   <MenuItem key={o} value={o}>
//                     {o}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {showOtherOrgInput && (
//               <TextField
//                 label="Enter Organisation Name"
//                 variant="outlined"
//                 required
//                 value={formData.organisation_name}
//                 onChange={(e) => setFormData((p) => ({ ...p, organisation_name: e.target.value }))}
//               />
//             )}

//             <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//               <TextField
//                 label="Email (Official)"
//                 variant="outlined"
//                 required
//                 fullWidth
//                 value={formData.email}
//                 onChange={(e) => {
//                   setFormData((p) => ({ ...p, email: e.target.value }));
//                   setOtpSent(false);
//                   setIsOtpVerified(false);
//                   setOtp("");
//                 }}
//               />
//               <Button
//                 variant="contained"
//                 endIcon={otpLoading ? <CircularProgress size={18} /> : <Send />}
//                 onClick={handleSendOtp}
//                 disabled={otpLoading || !canSendOtp}
//               >
//                 Send OTP
//               </Button>
//             </Box>

//             {otpSent && (
//               <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                 <TextField
//                   label="Enter OTP"
//                   variant="outlined"
//                   value={otp}
//                   onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
//                   helperText={USE_API ? "Enter the 6-digit code sent to your email" : "Static mode: Enter any 6-digit code"}
//                   inputProps={{ maxLength: 6 }}
//                 />
//                 <Button
//                   variant={isOtpVerified ? "contained" : "outlined"}
//                   color={isOtpVerified ? "success" : "primary"}
//                   startIcon={isOtpVerified ? <VerifiedUser /> : null}
//                   onClick={handleVerifyOtp}
//                   disabled={isOtpVerified || otpLoading}
//                 >
//                   {isOtpVerified ? "Verified" : "Verify OTP"}
//                 </Button>
//                 <Button onClick={handleSendOtp} disabled={otpLoading}>
//                   Resend OTP
//                 </Button>
//               </Box>
//             )}

//             <TextField
//               label="Password"
//               variant="outlined"
//               required
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={(e) => handlePasswordChange(e.target.value)}
//               helperText={passwordHelp || "Min 6 chars, include number & special char."}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowPassword((s) => !s)} edge="end">
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             <TextField
//               label="Confirm Password"
//               variant="outlined"
//               required
//               type={showPassword ? "text" : "password"}
//               value={formData.confirm_password}
//               onChange={(e) => setFormData((p) => ({ ...p, confirm_password: e.target.value }))}
//             />
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ px: 3, py: 2 }}>
//           <Button onClick={onClose} color="inherit" disabled={loading}>
//             Cancel
//           </Button>
//           <Button onClick={handleSubmit} variant="contained" disabled={loading || !isOtpVerified} startIcon={loading ? <CircularProgress size={18} /> : null}>
//             {loading ? "Registering..." : "Register"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <MessageCard open={snack.open} severity={snack.severity} message={snack.message} onClose={() => setSnack((s) => ({ ...s, open: false }))} />
//     </>
//   );
// };

// export default RegisterModal;








// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
//   IconButton,
//   InputAdornment,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Box,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { Visibility, VisibilityOff, Send, VerifiedUser, Close } from "@mui/icons-material";

// // In-memory storage for demo (shared with LoginModal)
// export let staticRegisteredUsers = [
//   { email: "user@demo.com", password: "user123", role: "user" },
//   { email: "admin@demo.com", password: "admin123", role: "admin" },
// ];

// const ORGANISATION_OPTIONS = [
//   "Adani Welspun Exploration Limited",
//   "ASAP Fluids Private Limited",
//   "Axens India (P) Limited",
//   "Baker Hughes",
//   "Bharat Petroleum Corporation Limited",
//   // ... (keeping your full list - truncated here for brevity)
//   "Other",
// ];

// const MessageCard = ({ open, severity = "info", message = "", onClose }) => {
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     if (open) {
//       setTimeout(() => setVisible(true), 10);
//       const timer = setTimeout(() => {
//         setVisible(false);
//         setTimeout(() => onClose?.(), 300);
//       }, 5000);
//       return () => clearTimeout(timer);
//     }
//     setVisible(false);
//   }, [open, onClose]);

//   if (!open && !visible) return null;

//   const palette = {
//     success: { bg: "#e6f4ea", accent: "#1e7e34", text: "#155724" },
//     error: { bg: "#f8d7da", accent: "#c82333", text: "#721c24" },
//     warning: { bg: "#fff3cd", accent: "#856404", text: "#856404" },
//     info: { bg: "#d1ecf1", accent: "#0c5460", text: "#0c5460" },
//   }[severity] || { bg: "#f8f9fa", accent: "#6c757d", text: "#495057" };

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: "24px",
//         left: "50%",
//         transform: `translateX(-50%) translateY(${visible ? 0 : -20}px)`,
//         opacity: visible ? 1 : 0,
//         transition: "all 0.3s ease",
//         zIndex: 1500,
//         minWidth: "320px",
//         maxWidth: "90vw",
//         background: palette.bg,
//         borderRadius: "12px",
//         boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
//         padding: "14px 18px",
//         display: "flex",
//         alignItems: "center",
//         gap: "14px",
//         color: palette.text,
//         border: `1px solid ${palette.accent}30`,
//       }}
//     >
//       <div
//         style={{
//           width: 38,
//           height: 38,
//           borderRadius: "50%",
//           background: `${palette.accent}15`,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontSize: "20px",
//           fontWeight: "bold",
//           color: palette.accent,
//         }}
//       >
//         {severity === "success" ? "✓" : severity === "error" ? "✕" : severity === "warning" ? "!" : "i"}
//       </div>

//       <div style={{ flex: 1 }}>
//         <div style={{ fontWeight: 600, fontSize: "1rem" }}>{message}</div>
//       </div>

//       <IconButton size="small" onClick={() => onClose?.()}>
//         <Close fontSize="small" />
//       </IconButton>
//     </div>
//   );
// };

// const RegisterModal = ({ onClose, onRegisterSuccess, open = true }) => {
//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     applicant_name: "",
//     applicant_phone: "",
//     designation: "",
//     organisation_name: "",
//     email: "",
//     password: "",
//     confirm_password: "",
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [showOtherOrgInput, setShowOtherOrgInput] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [isOtpVerified, setIsOtpVerified] = useState(false);
//   const [passwordHelp, setPasswordHelp] = useState("");

//   const [snack, setSnack] = useState({ open: false, severity: "info", message: "" });

//   const showMessage = (severity, message) => {
//     setSnack({ open: true, severity, message });
//   };

//   // Auto-fill applicant name
//   useEffect(() => {
//     const fullName = [formData.first_name, formData.last_name]
//       .filter(Boolean)
//       .join(" ")
//       .trim();
//     setFormData((prev) => ({ ...prev, applicant_name: fullName }));
//   }, [formData.first_name, formData.last_name]);

//   const handlePhoneChange = (value) => {
//     const digits = value.replace(/\D/g, "").slice(0, 10);
//     setFormData((p) => ({ ...p, applicant_phone: digits }));
//   };

//   const handleOrgSelect = (value) => {
//     if (value === "Other") {
//       setShowOtherOrgInput(true);
//       setFormData((p) => ({ ...p, organisation_name: "" }));
//     } else {
//       setShowOtherOrgInput(false);
//       setFormData((p) => ({ ...p, organisation_name: value }));
//     }
//   };

//   const validatePassword = (pw) => {
//     if (pw.length < 6) return "Password must be at least 6 characters";
//     if (!/\d/.test(pw)) return "Password must contain at least one number";
//     if (!/[!@#$%^&*(),.?\":{}|<>_\-\\[\]/`~+=]/.test(pw))
//       return "Password must contain at least one special character";
//     return "";
//   };

//   const handlePasswordChange = (value) => {
//     setFormData((p) => ({ ...p, password: value }));
//     setPasswordHelp(validatePassword(value));
//   };

// //   const isEmailAllowed = (org, email) => {
// //     if (!org || org === "Other") return true;
// //     const domain = email?.split("@").pop()?.toLowerCase();
// //     return !["gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "rediff.com"].includes(domain);
// //   };

//   const handleSendOtp = () => {
//     const email = formData.email.trim();
//     if (!email) {
//       showMessage("warning", "Please enter your email first");
//       return;
//     }

//     // if (!isEmailAllowed(formData.organisation_name, email)) {
//     //   showMessage("warning", "Please use an official organisation email address");
//     //   return;
//     // }

//     const emailExists = staticRegisteredUsers.some(
//       (u) => u.email.toLowerCase() === email.toLowerCase()
//     );

//     if (emailExists) {
//       showMessage("warning", "This email is already registered. Please login.");
//       return;
//     }

//     setOtpSent(true);
//     setOtp("");
//     setIsOtpVerified(false);
//     showMessage("success", `OTP sent to ${email} (Demo: use any 6-digit number)`);
//   };

//   const handleVerifyOtp = () => {
//     if (!otp || otp.length !== 6) {
//       showMessage("error", "Please enter a valid 6-digit OTP");
//       return;
//     }

//     // In static mode → any 6-digit code is accepted
//     setIsOtpVerified(true);
//     showMessage("success", "OTP verified successfully");
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (formData.password !== formData.confirm_password) {
//       showMessage("error", "Passwords do not match");
//       return;
//     }

//     const pwError = validatePassword(formData.password);
//     if (pwError) {
//       showMessage("warning", pwError);
//       return;
//     }

//     if (formData.applicant_phone.length !== 10) {
//       showMessage("error", "Phone number must be exactly 10 digits");
//       return;
//     }

//     // if (!isEmailAllowed(formData.organisation_name, formData.email)) {
//     //   showMessage("warning", "Please use an official organisation email address");
//     //   return;
//     // }

//     if (!isOtpVerified) {
//       showMessage("warning", "Please verify your email with OTP first");
//       return;
//     }

//     setLoading(true);

//     setTimeout(() => {
//       const email = formData.email.trim().toLowerCase();

//       if (staticRegisteredUsers.some((u) => u.email.toLowerCase() === email)) {
//         setLoading(false);
//         showMessage("error", "This email is already registered");
//         return;
//       }

//       staticRegisteredUsers.push({
//         email: formData.email,
//         password: formData.password,
//         role: "user",
//         first_name: formData.first_name,
//         last_name: formData.last_name,
//         organisation_name: formData.organisation_name,
//         designation: formData.designation,
//         phone: formData.applicant_phone,
//       });

//       setLoading(false);
//       showMessage("success", "Registration successful! You can now login.");

//       setTimeout(() => {
//         onRegisterSuccess?.();
//         onClose?.();
//       }, 1800);
//     }, 900);
//   };

//   return (
//     <>
//       <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//         <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//           <Typography variant="h6">Create Account</Typography>
//           <IconButton onClick={onClose} size="small">
//             <Close />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent dividers>
//           <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", gap: 2.2 }}>
//             <Box sx={{ display: "flex", gap: 1.5 }}>
//               <TextField
//                 label="First Name"
//                 required
//                 fullWidth
//                 value={formData.first_name}
//                 onChange={(e) => setFormData((p) => ({ ...p, first_name: e.target.value }))}
//               />
//               <TextField
//                 label="Last Name"
//                 required
//                 fullWidth
//                 value={formData.last_name}
//                 onChange={(e) => setFormData((p) => ({ ...p, last_name: e.target.value }))}
//               />
//             </Box>

//             <TextField
//               label="Applicant Phone"
//               required
//               fullWidth
//               value={formData.applicant_phone}
//               onChange={(e) => handlePhoneChange(e.target.value)}
//               helperText={
//                 formData.applicant_phone && formData.applicant_phone.length !== 10
//                   ? "Exactly 10 digits required"
//                   : " "
//               }
//               InputProps={{
//                 startAdornment: <InputAdornment position="start">+91</InputAdornment>,
//               }}
//             />

//             <TextField
//               label="Designation"
//               required
//               fullWidth
//               value={formData.designation}
//               onChange={(e) => setFormData((p) => ({ ...p, designation: e.target.value }))}
//             />

           

//             <FormControl fullWidth>
//               {/* <InputLabel>Organisation Name</InputLabel> */}

//                <TextField
//               label="Organisation Name"
//               required
//               fullWidth
//               value={formData.organisation_name}
//               onChange={(e) => setFormData((p) => ({ ...p, organisation_name: e.target.value }))}
//             />


//               {/* <Select
//                 value={showOtherOrgInput ? "Other" : formData.organisation_name || ""}
//                 label="Organisation"
//                 onChange={(e) => handleOrgSelect(e.target.value)}
//               >
//                 {ORGANISATION_OPTIONS.map((org) => (
//                   <MenuItem key={org} value={org}>
//                     {org}
//                   </MenuItem>
//                 ))}
//               </Select> */}
//             </FormControl>

//             {/* {showOtherOrgInput && (
//               <TextField
//                 label="Enter Organisation Name"
//                 required
//                 fullWidth
//                 value={formData.organisation_name}
//                 onChange={(e) => setFormData((p) => ({ ...p, organisation_name: e.target.value }))}
//               />
//             )} */}

//             <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>
//               <TextField
//                 label="Official Email"
//                 required
//                 fullWidth
//                 type="email"
//                 value={formData.email}
//                 onChange={(e) => {
//                   setFormData((p) => ({ ...p, email: e.target.value }));
//                   setOtpSent(false);
//                   setIsOtpVerified(false);
//                   setOtp("");
//                 }}
//                 // helperText="Use your official organisation email"
//               />

//               <Button
//                 variant="contained"
//                 size="medium"
//                 onClick={handleSendOtp}
//                 disabled={otpSent || !formData.email.trim() || !formData.organisation_name}
//                 sx={{ mt: "8px", minWidth: 110 }}
//               >
//                 Send OTP
//               </Button>
//             </Box>

//             {otpSent && (
//               <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>
//                 <TextField
//                   label="OTP"
//                   required
//                   value={otp}
//                   onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
//                   inputProps={{ maxLength: 6 }}
//                   sx={{ flex: 1 }}
//                   helperText="Enter any 6-digit code (demo mode)"
//                 />

//                 <Button
//                   variant={isOtpVerified ? "contained" : "outlined"}
//                   color={isOtpVerified ? "success" : "primary"}
//                   onClick={handleVerifyOtp}
//                   disabled={isOtpVerified || !otp}
//                   startIcon={isOtpVerified ? <VerifiedUser /> : null}
//                   sx={{ mt: "8px", minWidth: 110 }}
//                 >
//                   {isOtpVerified ? "Verified" : "Verify"}
//                 </Button>
//               </Box>
//             )}

//             <TextField
//               label="Password"
//               required
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={(e) => handlePasswordChange(e.target.value)}
//               helperText={passwordHelp || "Min 6 chars, number & special character"}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowPassword(!showPassword)}>
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <TextField
//               label="Confirm Password"
//               required
//               type={showPassword ? "text" : "password"}
//               value={formData.confirm_password}
//               onChange={(e) => setFormData((p) => ({ ...p, confirm_password: e.target.value }))}
//             />
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ px: 3, py: 2 }}>
//           <Button onClick={onClose} color="inherit" disabled={loading}>
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleSubmit}
//             disabled={loading || !isOtpVerified}
//             startIcon={loading ? <CircularProgress size={20} /> : null}
//           >
//             {loading ? "Creating Account..." : "Register"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <MessageCard
//         open={snack.open}
//         severity={snack.severity}
//         message={snack.message}
//         onClose={() => setSnack((s) => ({ ...s, open: false }))}
//       />
//     </>
//   );
// };

// export default RegisterModal;




import React, { useState } from "react";
import api from "../service/axios_config";

import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, IconButton, InputAdornment,
  Box, CircularProgress, Snackbar, Alert
} from "@mui/material";

import {
  Visibility, VisibilityOff, VerifiedUser, Close
} from "@mui/icons-material";

const RegisterModal = ({ onClose, onRegisterSuccess, open = true }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    applicant_phone: "",
    designation: "",
    organisation_name: "",
    email: "",
    password: "",
    confirm_password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);

  /* 🔥 Snackbar State */
  const [toast, setToast] = useState({
    open: false,
    severity: "info",
    message: "",
  });

  const showToast = (severity, message) => {
    setToast({ open: true, severity, message });
  };

  const closeToast = () => {
    setToast((t) => ({ ...t, open: false }));
  };

  /* ---------- Helpers ---------- */
  const validatePassword = (pw) => {
    if (pw.length < 6) return "Password must be at least 6 characters";
    if (!/\d/.test(pw)) return "Password must contain a number";
    if (!/[!@#$%^&*]/.test(pw)) return "Password must contain a special character";
    return "";
  };

  const handlePhoneChange = (v) => {
    setFormData(p => ({ ...p, applicant_phone: v.replace(/\D/g, "").slice(0, 10) }));
  };

  /* ================= OTP FLOW ================= */

  const handleSendOtp = async () => {
    if (!formData.email) {
      showToast("warning", "Please enter email first");
      return;
    }

    try {
      setLoading(true);
      await api.post("/otp/generate/", { email: formData.email });
      setOtpSent(true);
      setIsOtpVerified(false);
      showToast("success", "OTP sent to your email");
    } catch (err) {
      showToast("error", err.response?.data?.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      showToast("warning", "Enter valid 6-digit OTP");
      return;
    }

    try {
      setLoading(true);
      await api.post("/otp/verify/", {
        email: formData.email,
       otp_code: otp,
      });
      setIsOtpVerified(true);
      showToast("success", "OTP verified successfully");
    } catch (err) {
      showToast("error", err.response?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setLoading(true);
      await api.post("/otp/resend/", { email: formData.email });
      showToast("info", "OTP resent successfully");
    } catch {
      showToast("error", "Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  /* ================= REGISTER ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isOtpVerified) {
      showToast("warning", "Please verify OTP first");
      return;
    }

    if (formData.password !== formData.confirm_password) {
      showToast("error", "Passwords do not match");
      return;
    }

    const pwErr = validatePassword(formData.password);
    if (pwErr) {
      showToast("warning", pwErr);
      return;
    }

    try {
      setLoading(true);
      await api.post("/auth/register/", {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        password: formData.password,
        applicant_phone: formData.applicant_phone,
        designation: formData.designation,
        organisation_name: formData.organisation_name,
      });

      showToast("success", "Registration successful 🎉");
      setTimeout(() => {
        onRegisterSuccess?.();
        onClose?.();
      }, 1500);
    } catch (err) {
      showToast("error", err.response?.data?.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>
          Create Account
          <IconButton onClick={onClose} sx={{ float: "right" }}>
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ display: "grid", gap: 2 }}>

            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField label="First Name" fullWidth required
                onChange={e => setFormData(p => ({ ...p, first_name: e.target.value }))} />
              <TextField label="Last Name" fullWidth required
                onChange={e => setFormData(p => ({ ...p, last_name: e.target.value }))} />
            </Box>

            <TextField label="Phone"
              value={formData.applicant_phone}
              onChange={e => handlePhoneChange(e.target.value)}
              InputProps={{ startAdornment: <InputAdornment position="start">+91</InputAdornment> }}
            />

            <TextField label="Designation" required
              onChange={e => setFormData(p => ({ ...p, designation: e.target.value }))} />

            <TextField label="Organisation Name" required
              onChange={e => setFormData(p => ({ ...p, organisation_name: e.target.value }))} />

            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField label="Email" fullWidth required
                onChange={e => {
                  setFormData(p => ({ ...p, email: e.target.value }));
                  setOtpSent(false);
                  setIsOtpVerified(false);
                  setOtp("");
                }} />

              <Button onClick={handleSendOtp} disabled={loading || otpSent}>
                Send OTP
              </Button>
            </Box>

            {otpSent && (
              <Box sx={{ display: "flex", gap: 1 }}>
                <TextField
                  label="OTP"
                  value={otp}
                  onChange={e => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                />

                <Button
                  variant={isOtpVerified ? "contained" : "outlined"}
                  color={isOtpVerified ? "success" : "primary"}
                  onClick={handleVerifyOtp}
                  disabled={isOtpVerified}
                  startIcon={isOtpVerified && <VerifiedUser />}
                >
                  {isOtpVerified ? "Verified" : "Verify"}
                </Button>

                {!isOtpVerified && (
                  <Button onClick={handleResendOtp}>Resend</Button>
                )}
              </Box>
            )}

            <TextField label="Password"
              type={showPassword ? "text" : "password"}
              onChange={e => setFormData(p => ({ ...p, password: e.target.value }))}
              InputProps={{
                endAdornment: (
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ),
              }} />

            <TextField label="Confirm Password"
              type={showPassword ? "text" : "password"}
              onChange={e => setFormData(p => ({ ...p, confirm_password: e.target.value }))} />

          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            // disabled={loading || !isOtpVerified}
            onClick={handleSubmit}
            startIcon={loading && <CircularProgress size={20} />}
          >
            Register
          </Button>
        </DialogActions>
      </Dialog>

      {/* 🔥 SEXY SNACKBAR */}
      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={closeToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={toast.severity} variant="filled" onClose={closeToast}>
          {toast.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default RegisterModal;
